import React from "react";
import "./StatusLegend.css";
import { useTranslation } from "react-i18next";

const StatusLegend = () => {
  const { t } = useTranslation();

  const legendItems = [
    { label: t("status_legend.bo_booked"), color: "linear-gradient(135deg, #e07a5f, #b95441)" },
    { label: t("status_legend.ap_approved"), color: "linear-gradient(135deg, #f4d35e, #f6bd60)" },
    { label: t("status_legend.pw_payment_completed_practitioner_incomplete"), color: "linear-gradient(135deg, #9c27b0, #7b1fa2)" },
    { label: t("status_legend.ca_cancelled"), color: "linear-gradient(135deg, #a0aec0, #718096)" },
    { label: t("status_legend.co_completed"), color: "linear-gradient(135deg, #1e88e5, #1565c0)" },
    { label: t("status_legend.pc_payment_completed"), color: "linear-gradient(135deg, #4caf50, #087f23)" }
  ];
  

  return (
    <div className="status-legend">
      <div className="legend-items">
        {legendItems.map((item, index) => (
          <div key={index} className="legend-item">
            <span className="legend-color" style={{ background: item.color }}></span>
            <span className="legend-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusLegend;
